export default "__VITE_ASSET__MMQWwNYv__"